function formVacancy() {
  init();
}
function init() {
  var form = jQuery('#apply_form');
  var translatedWords = [{
    en: 'Introduction',
    de: 'Einführung'
  }, {
    en: 'Organization',
    de: 'Organisation / Abteilung'
  }, {
    en: 'Function',
    de: 'Job-Beschreibung'
  }, {
    en: 'Requirements',
    de: 'Job-Anforderungen'
  }, {
    en: 'Information',
    de: 'Informationen bei'
  }, {
    en: 'Application',
    de: 'Bewerben bei'
  }];
  var words = jQuery('.section-vacancy .cx_h4');
  changeSubmitName(form);
  translateWords(words, translatedWords);
}
function changeSubmitName(form) {
  if (!form) return;
  var submit_1 = form.find('.cx2_applyform-apply');
  submit_1.val('Jetzt absenden');
  var submit_2 = jQuery('.cx2_vacancydetails-apply');
  submit_2.text('Auf diese Stelle Bewerben');
  var submit_3 = jQuery('#logged_out a');
  submit_3.text('Anmelden');
  jQuery('.cx_msgBox_success').text('Vielen Dank für ihre Bewerbung! Wir setzen uns sobald wie moglich mit lhnen in Verbindung.');
}
function translateWords(wordsArray, translatedWordsArray) {
  for (var i = 0; i < wordsArray.length - 1; i++) {
    var item = wordsArray[i];
    var classObj = item.className;
    var translatedWord = translatedWordsArray[i].en.toLowerCase();
    if (classObj.includes(translatedWord)) {
      jQuery(item).text(translatedWordsArray[i].de);
    }
  }
}
export default formVacancy;